import React from "react";

const NoMatching = () => {
  return (
    <div className="mx-20 overflow-hidden">
      <img src="/freelancers/build/no-results.webp" className="object-cover" />
    </div>
  );
};

export default NoMatching;
